import React, { useEffect, useState } from "react";
import TextField from "../common/TextField";
import { Alert, FormControl, Grid2, InputLabel, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import './calculator.css';
import AtomTextField from "../common/TextField";
const ManagementCalculator = () => {
    const [formInfo, setFormInfo] = useState({
        Capital: 6000000,
        Mangement: 2.00,
        otherExpense: "0.15",
        performance: 15.00,
        rateOfReturn: 10.00,
        bokarAge: "0.20"
    })
    const [gross, setGross] = useState({
        y1Gross: 20,
        y2Gross: -12,
        y3Gross: 0,
        y4Gross: 80,
        y5Gross: 30
    })
    const [tableData, setTableData] = useState([])
    let y1NetValue;
    let y2NetValue;
    let y3NetValue;
    let y4NetValue;
    let y1HWM;
    let y2HWM;
    let y3HWM;
    let y4HWM;
    const [error, setError] = useState('')
    const [feeType, setFeeType] = useState('Hybrid Fee Structure')
    const regNumber = /^\d*\.?\d*$/
    const regNegNumber=/^-?\d*$/
   const onlyNumbers = /\D/g
     const validateNumbers = (value) => {
        return value?.replace(onlyNumbers, '')
      }
      const valueSeperate = (items) => {
        return items.toLocaleString('en-IN')
      }
    const handleChange = (e) => {
        let { name, value } = e;
       
            if (name === 'Capital') { 
                if (typeof value !== 'number' && value?.includes(',')) {
                    value = value?.replaceAll(',', '')
                  }
                  if (typeof value !== 'number') {
                    value = validateNumbers(value)
                  }
                  let inputValues = valueSeperate(value)
                    setError("")
                    setFormInfo({
                        ...formInfo,
                        Capital: inputValues
                    })
                
            } if (regNumber.test(value)) {
            if (name === "Mangement") {
                if (value >= 0 && value <= 2.5) {
                    setError("")
                    setFormInfo({
                        ...formInfo,
                        Mangement: value,
                    });
                } else {
                    setError("Should be in the Range of 0% -2.5%")
                }
            }
            if (name === "performance") {
                if (value >= 0 && value <= 25) {
                    setError("")
                    setFormInfo({
                        ...formInfo,
                        performance: value,
                    });
                } else {
                    setError("Should be in the Range of 0% -  25%")
                }
            }
            if (name === "rateOfReturn") {
                if (value >= 0 && value <= 15) {
                    setError("")
                    setFormInfo({
                        ...formInfo,
                        rateOfReturn: value,
                    });
                } else {
                    setError("Should be in the Range of 0% -  15%")
                }
            }
        }
    }
    const handleDropDownChange = (e) => {
        const { name, value } = e.target;

        if (value === "Performance Fee Structure") {
            setFormInfo({
                ...formInfo,
                Mangement: 0,
                performance: 15.00,
                rateOfReturn
                    : 10.00
            })
        }
        if (value === "Fixed Fee Structure") {
            setFormInfo({
                ...formInfo,
                Mangement:2.5,
                performance: 0,
                rateOfReturn
                    : 0
            })
        }
        if (value === "Hybrid Fee Structure") {
            setFormInfo({
                ...formInfo,
                Mangement: 2,
                performance: 15.00,
                rateOfReturn
                    : 10.00
            })
        }
        setFeeType(value)
    }

    const rows = [
        {
            id: "i", Fee: "Capital Contributed /Assets under Management ", formula: "i = a", y1: "", y2: ""
        },
        {
            id: "ii", Fee: "Gain / (Loss) on Investment based on the Scenario  ", formula: "ii = i * Scenario", y1: "", y2: ""
        },
        {
            id: "iii", Fee: "Gross Value of the Portfolio at the end of the year ", formula: "iii = i + ii", y1: "", y2: ""
        },
        {
            id: "iv", Fee: "Daily Weighted Average assets under management ", formula: "iv = (iii + i) / 2", y1: "", y2: ""
        },
        {
            id: "v", Fee: "Other Expense", formula: "v = iv * c", y1: "", y2: ""
        },
        {
            id: "vi", Fee: "Brokerage and Transaction cost", formula: "vi = iv * f", y1: "", y2: ""
        },
        {
            id: "vii", Fee: "Management Fees ", formula: "vii - (iv + v + vi) * b", y1: "", y2: ""
        },
        {
            id: "viii", Fee: "Total charges during the year (Sum of v, vi and vii)", formula: "viii = v + vi + vii", y1: "", y2: ""
        },
        {
            id: "ix", Fee: "Value of the Portfolio before Performance fee ", formula: "ix = iii + viiii", y1: "", y2: ""
        },
        {
            id: "x", Fee: "High Water Mark Value (HWM)", formula: "x = For 1st Year its i and for consecutive years its xviii of previous year", y1: "", y2: ""
        },
        {
            id: "xi", Fee: "Hurdle Rate of return ", formula: "xi = Max of (x, i ) * e", y1: "", y2: ""
        },
        {
            id: "xii", Fee: "Portfolio value in excess of Hurdle Rate Return", formula: "xii = ix > (x + xi) then (ix - x - xi) else 0", y1: "", y2: ""
        },
        {
            id: "xiii", Fee: "Profit share of the PMS", formula: "xiii = xii * d", y1: "", y2: ""
        },
        {
            id: "xiv", Fee: "Profit Share To be taken by PMS", formula: "xiv = xiii", y1: "", y2: ""
        },
        {
            id: "xv", Fee: "Is the Performance Fee charged?", formula: "xv = xiii > 0 then 'Yes' else No P Fees", y1: "", y2: ""
        },
        {
            id: "xvi", Fee: "Net value of the Portfolio at the end of the year after all fees and expenses", formula: "xvi = ix - xiii", y1: "", y2: ""
        },
        {
            id: "xvii", Fee: "% Portfolio Return ", formula: "xvii = (xvi /i) - 1)%", y1: "", y2: ""
        },
        {
            id: "xviii", Fee: "High Water Mark to be carried forward for next year", formula: "xviii = xv = 'Yes' then ix else max of (ix , i ,xviii of previous year)", y1: "", y2: ""
        }
    ]
    let rowData = rows
    const rules = [
        { id: 1, Name: "In the illustration, Management fee is assumed to be charged annually. However, the Portfolio Manager charges fee Monthly/Quarterly as defined in the Fee Schedule which is part of PMS agreement" },
        { id: 2, Name: "Management Fees and Other Expenses are to be calculated on the average daily portfolio value payable on a monthly/quarterly basis at the end of each calendar month/quarter, as may be defined in Fee schedule. " },
        { id: 3, Name: "Returns are assumed to be generated linearly through the year." },
        { id: 4, Name: "Other Expenses includes Account Opening charges, stamp duty /Audit Fee/ Bank charges / Fund Accounting charges / Custody Fee / demat charges or other miscellaneous expense, as may be defined in Fee schedule. " },
        { id: 5, Name: "Brokerage and transaction cost for the illustration purpose is charged on the Average AUM. However, Brokerage and Transaction cost are charged on basis the actuals trades. " },
        { id: 6, Name: "All Fees and charges are subject to GST." },
        { id: 7,
        Name: "For this illustration, High Water Mark for the 1st Year is the Capital invested and from second year onwards if performance fee is charged, it’s the year end closing value after all charges and fees, else it remains the same, if applicable" },
        { id: 8, Name: "For this illustration, Hurdle rate is calculated on Higher of (HWM or previous year closing capital). However, in actual Hurdle Rate of return is defined in the Fee Schedule and may differ from this illustration, if applicable" },
        { id: 9, Name: "Hurdle rate is prorated in case the performance fee period is less than 1 year OR if there are inflow/outflows from the portfolio during the computation period, if applicable" },
        { id: 10, Name:"If applicable, the Performance linked fee shall be charged on the basis of high water mark principle over the life of the investment. Value of the portfolio shall be taken to be the value on the date when the performance fee was charged. The performance linked fee shall be charged only on increase in portfolio value in excess of previously achieved high water mark and performance fees will be charges on annual basis or at the time of redemption, as applicable."},
        { id: 11, Name: "Average daily portfolio value means the value of the portfolio of each client determined in accordance with the relevant provisions of the agreement executed with the client and includes both realized and unrealized gains/ losses. " },
        { id: 12, Name: "The “Profit share of the PMS” is equal to “Profit Share To be taken by PMS” with an assumption that the client is on direct mode." },
        { id: 13, Name: "In addition to the above expense/fee, exit load shall be charged on the Post Peformance fee AUM, if applicable as per the fee schedule." }
    ]
    const updateCalculatedValues = () => {
        const tempRow = JSON.parse(JSON.stringify(rowData))
        tempRow.forEach((row, index) => {
            let tempobj = { ...row }
            switch (index) {
                case 0:
                    tempobj['y1'] = Math.round((formInfo.Capital), 0);
                    tempRow[0] = tempobj
                    break;

                case 1:
                    const calValue = (gross.y1Gross) / 100
                    tempobj['y1'] = Number(formInfo.Capital) * calValue;
                    tempRow[1] = tempobj
                    break;
                case 2:
                    tempobj['y1'] = tempRow[0].y1 + tempRow[1].y1
                    tempRow[2] = tempobj
                    break;
                case 3:
                    tempobj['y1'] = (tempRow[2].y1 + tempRow[0].y1) / 2
                    tempRow[3] = tempobj
                    break;
                case 4:
                    tempobj['y1'] = -(tempRow[3].y1 * (parseFloat(formInfo.otherExpense) / 100))
                    tempRow[4] = tempobj
                    break;
                case 5:
                    const brokValue = (parseFloat(formInfo.bokarAge) / 100)
                    const result = -(Math.round(tempRow[3].y1 * brokValue, 0))
                    tempobj['y1'] = result
                    tempRow[5] = tempobj
                    break;
                case 6:
                    tempobj['y1'] = -(Math.round((tempRow[3].y1 + tempRow[4].y1 + tempRow[5].y1) * (parseFloat(formInfo.Mangement) / 100), 0))
                    tempRow[6] = tempobj
                    break;
                case 7:
                    tempobj['y1'] = Math.round((tempRow[4].y1 + tempRow[5].y1 + tempRow[6].y1), 0)
                    tempRow[7] = tempobj
                    break;
                case 8:
                    tempobj['y1'] = Math.round((tempRow[2].y1 + tempRow[7].y1), 0)
                    tempRow[8] = tempobj
                    break;
                case 9:
                    tempobj['y1'] = Math.round((tempRow[0].y1), 0)
                    tempRow[9] = tempobj
                    break;
                case 10:
                    tempobj['y1'] = Math.round((Math.max(tempRow[9].y1, tempRow[0].y1)) * (parseFloat(formInfo.rateOfReturn) / 100), 0)
                    tempRow[10] = tempobj
                    break;
                case 11:
                    if (tempRow[8].y1 > (tempRow[9].y1 + tempRow[10].y1)) {
                        tempobj['y1'] = Math.round((tempRow[8].y1 - tempRow[9].y1 - tempRow[10].y1), 0)
                        tempRow[11] = tempobj
                    } else {
                        tempobj['y1'] = 0
                        tempRow[11] = tempobj
                    }
                    break;
                case 12:
                    tempobj['y1'] = Math.round((tempRow[11].y1 * (parseFloat(formInfo.performance) / 100)), 0)
                    tempRow[12] = tempobj
                    break;
                case 13:
                    tempobj['y1'] = Math.round(tempRow[12].y1, 0)
                    tempRow[13] = tempobj
                    break;
                case 14:
                    if (tempRow[12].y1 > 0) {
                        tempobj['y1'] = "Yes"
                        tempRow[14] = tempobj
                    }
                    else {
                        tempobj['y1'] = "No P Fees"
                        tempRow[14] = tempobj
                    }
                    break;
                case 15:
                    tempobj['y1'] = Math.round((tempRow[8].y1 - tempRow[12].y1), 0)
                    tempRow[15] = tempobj
                    y1NetValue = tempobj['y1']
                    break;
                case 16:
                    tempobj['y1'] = `${(((tempRow[15].y1 / tempRow[0].y1) - 1) * 100).toFixed(2)}%`
                    tempRow[16] = tempobj
                    break;
                case 17:
                    if (tempRow[14].y1 === "Yes") {
                        tempobj['y1'] = tempRow[8].y1
                        tempRow[17] = tempobj
                        y1HWM = tempobj['y1']
                    } else {
                        tempobj['y1'] = Math.max(tempRow[8].y1, tempRow[0].y1)
                        tempRow[17] = tempobj
                        y1HWM = tempobj['y1']
                    }
                    break;
                default:
                    return null;
            }
        }
        )
        rowData = JSON.parse(JSON.stringify(tempRow))
    }
    const updateCalculatedy2Values = () => {
        const tempRow = JSON.parse(JSON.stringify(rowData))
        tempRow.forEach((row, index) => {
            let tempobj = { ...row }
            switch (index) {
                case 0:
                    tempobj['y2'] = y1NetValue;
                    tempRow[0] = tempobj
                    break;

                case 1:
                    const calValue = (gross.y2Gross) / 100
                    tempobj['y2'] = Math.round(y1NetValue * calValue, 0);
                    tempRow[1] = tempobj
                    break;
                case 2:
                    tempobj['y2'] = Math.round(tempRow[0].y2 + tempRow[1].y2, 0)
                    tempRow[2] = tempobj
                    break;
                case 3:
                    tempobj['y2'] = Math.round((tempRow[2].y2 + tempRow[0].y2) / 2, 0)
                    tempRow[3] = tempobj
                    break;
                case 4:
                    tempobj['y2'] = -(Math.round(tempRow[3].y2 * (parseFloat(formInfo.otherExpense) / 100), 0))
                    tempRow[4] = tempobj
                    break;
                case 5:
                    const brokValue = (parseFloat(formInfo.bokarAge) / 100)
                    const result = -(Math.round(tempRow[3].y2 * brokValue, 0))
                    tempobj['y2'] = result
                    tempRow[5] = tempobj
                    break;
                case 6:
                    tempobj['y2'] = -(Math.round((tempRow[3].y2 + tempRow[4].y2 + tempRow[5].y2) * (parseFloat(formInfo.Mangement) / 100), 0))
                    tempRow[6] = tempobj
                    break;
                case 7:
                    tempobj['y2'] = Math.round((tempRow[4].y2 + tempRow[5].y2 + tempRow[6].y2), 0)
                    tempRow[7] = tempobj
                    break;
                case 8:
                    tempobj['y2'] = Math.round((tempRow[2].y2 + tempRow[7].y2), 0)
                    tempRow[8] = tempobj
                    break;
                case 9:
                    tempobj['y2'] = Math.round(y1HWM, 0)
                    tempRow[9] = tempobj
                    break;
                case 10:
                    tempobj['y2'] = Math.round((Math.max(tempRow[9].y2, tempRow[0].y2)) * (parseFloat(formInfo.rateOfReturn) / 100), 0)
                    tempRow[10] = tempobj
                    break;
                case 11:
                    if (tempRow[8].y2 > (tempRow[9].y2 + tempRow[10].y2)) {
                        tempobj['y2'] = Math.round((tempRow[8].y2 - tempRow[9].y2 - tempRow[10].y2), 0)
                        tempRow[11] = tempobj
                    } else {
                        tempobj['y2'] = 0
                        tempRow[11] = tempobj
                    }
                    break;
                case 12:
                    tempobj['y2'] = Math.round((tempRow[11].y2 * (parseFloat(formInfo.performance) / 100)), 0)
                    tempRow[12] = tempobj
                    break;
                case 13:
                    tempobj['y2'] = Math.round(tempRow[12].y2, 0)
                    tempRow[13] = tempobj
                    break;
                case 14:
                    if (tempRow[12].y2 > 0) {
                        tempobj['y2'] = "Yes"
                        tempRow[14] = tempobj
                    }
                    else {
                        tempobj['y2'] = "No P Fees"
                        tempRow[14] = tempobj
                    }
                    break;
                case 15:
                    tempobj['y2'] = Math.round((tempRow[8].y2 - tempRow[12].y2), 0)
                    tempRow[15] = tempobj
                    y2NetValue = tempobj['y2']
                    break;
                case 16:
                    tempobj['y2'] = `${(((tempRow[15].y2 / tempRow[0].y2) - 1) * 100).toFixed(2)}%`
                    tempRow[16] = tempobj
                    break;
                case 17:
                    if (tempRow[14].y2 === "Yes") {
                        tempobj['y2'] = tempRow[8].y2
                        tempRow[17] = tempobj
                        y2HWM = tempobj['y2']

                    } else {
                        tempobj['y2'] = Math.max(tempRow[8].y2, tempRow[0].y2, y1HWM)
                        tempRow[17] = tempobj
                        y2HWM = tempobj['y2']
                    }
                    break;
                default:
                    return null;
            }
        }
        )
        rowData = JSON.parse(JSON.stringify(tempRow))
    }

    const updateCalculatedy3Values = () => {
        const tempRow = JSON.parse(JSON.stringify(rowData))
        tempRow.forEach((row, index) => {
            let tempobj = { ...row }
            switch (index) {
                case 0:
                    tempobj['y3'] = y2NetValue;
                    tempRow[0] = tempobj
                    break;

                case 1:
                    const calValue = (gross.y3Gross) / 100
                    tempobj['y3'] = Math.round(y2NetValue * calValue, 0);
                    tempRow[1] = tempobj
                    break;
                case 2:
                    tempobj['y3'] = Math.round(tempRow[0].y3 + tempRow[1].y3, 0)
                    tempRow[2] = tempobj
                    break;
                case 3:
                    tempobj['y3'] = Math.round((tempRow[2].y3 + tempRow[0].y3) / 2, 0)
                    tempRow[3] = tempobj
                    break;
                case 4:
                    tempobj['y3'] = -(Math.round(tempRow[3].y3 * (parseFloat(formInfo.otherExpense) / 100), 0))
                    tempRow[4] = tempobj
                    break;
                case 5:
                    const brokValue = (parseFloat(formInfo.bokarAge) / 100)
                    const result = -(Math.round(tempRow[3].y3 * brokValue, 0))
                    tempobj['y3'] = result
                    tempRow[5] = tempobj
                    break;
                case 6:
                    tempobj['y3'] = -(Math.round((tempRow[3].y3 + tempRow[4].y3 + tempRow[5].y3) * (parseFloat(formInfo.Mangement) / 100), 0))
                    tempRow[6] = tempobj
                    break;
                case 7:
                    tempobj['y3'] = Math.round((tempRow[4].y3 + tempRow[5].y3 + tempRow[6].y3), 0)
                    tempRow[7] = tempobj
                    break;
                case 8:
                    tempobj['y3'] = Math.round((tempRow[2].y3 + tempRow[7].y3), 0)
                    tempRow[8] = tempobj
                    break;
                case 9:
                    tempobj['y3'] = Math.round(y2HWM, 0)
                    tempRow[9] = tempobj
                    break;
                case 10:
                    tempobj['y3'] = Math.round((Math.max(tempRow[9].y3, tempRow[0].y3)) * (parseFloat(formInfo.rateOfReturn) / 100), 0)
                    tempRow[10] = tempobj
                    break;
                case 11:
                    if (tempRow[8].y3 > (tempRow[9].y3 + tempRow[10].y3)) {
                        tempobj['y3'] = Math.round((tempRow[8].y3 - tempRow[9].y3 - tempRow[10].y3), 0)
                        tempRow[11] = tempobj
                    } else {
                        tempobj['y3'] = 0
                        tempRow[11] = tempobj
                    }
                    break;
                case 12:
                    tempobj['y3'] = Math.round((tempRow[11].y3 * (parseFloat(formInfo.performance) / 100)), 0)
                    tempRow[12] = tempobj
                    break;
                case 13:
                    tempobj['y3'] = Math.round(tempRow[12].y3, 0)
                    tempRow[13] = tempobj
                    break;
                case 14:
                    if (tempRow[12].y3 > 0) {
                        tempobj['y3'] = "Yes"
                        tempRow[14] = tempobj
                    }
                    else {
                        tempobj['y3'] = "No P Fees"
                        tempRow[14] = tempobj
                    }
                    break;
                case 15:
                    tempobj['y3'] = Math.round((tempRow[8].y3 - tempRow[12].y3), 0)
                    tempRow[15] = tempobj
                    y3NetValue = tempobj['y3']
                    break;
                case 16:
                    tempobj['y3'] = `${(((tempRow[15].y3 / tempRow[0].y3) - 1) * 100).toFixed(2)}%`
                    tempRow[16] = tempobj
                    break;
                case 17:
                    if (tempRow[14].y3 === "Yes") {
                        tempobj['y3'] = tempRow[8].y3
                        tempRow[17] = tempobj
                        y3HWM = tempobj['y3']
                    } else {
                        tempobj['y3'] = Math.max(tempRow[8].y3, tempRow[0].y3, y2HWM)
                        tempRow[17] = tempobj
                        y3HWM = tempobj['y3']
                    }
                    break;
                default:
                    return null;
            }
        }
        )
        rowData = JSON.parse(JSON.stringify(tempRow))
        setTableData(rowData)
    }
    const updateCalculatedy4Values = () => {
        const tempRow = JSON.parse(JSON.stringify(rowData))
        tempRow.forEach((row, index) => {
            let tempobj = { ...row }
            switch (index) {
                case 0:
                    tempobj['y4'] = y3NetValue;
                    tempRow[0] = tempobj
                    break;

                case 1:
                    const calValue = (gross.y4Gross) / 100
                    tempobj['y4'] = Math.round(y3NetValue * calValue, 0);
                    tempRow[1] = tempobj
                    break;
                case 2:
                    tempobj['y4'] = Math.round(tempRow[0].y4 + tempRow[1].y4, 0)
                    tempRow[2] = tempobj
                    break;
                case 3:
                    tempobj['y4'] = Math.round((tempRow[2].y4 + tempRow[0].y4) / 2, 0)
                    tempRow[3] = tempobj
                    break;
                case 4:
                    tempobj['y4'] = -(Math.round(tempRow[3].y4 * (parseFloat(formInfo.otherExpense) / 100), 0))
                    tempRow[4] = tempobj
                    break;
                case 5:
                    const brokValue = (parseFloat(formInfo.bokarAge) / 100)
                    const result = -(Math.round(tempRow[3].y4 * brokValue, 0))
                    tempobj['y4'] = result
                    tempRow[5] = tempobj
                    break;
                case 6:
                    tempobj['y4'] = -(Math.round((tempRow[3].y4 + tempRow[4].y4 + tempRow[5].y4) * (parseFloat(formInfo.Mangement) / 100), 0))
                    tempRow[6] = tempobj
                    break;
                case 7:
                    tempobj['y4'] = Math.round((tempRow[4].y4 + tempRow[5].y4 + tempRow[6].y4), 0)
                    tempRow[7] = tempobj
                    break;
                case 8:
                    tempobj['y4'] = Math.round((tempRow[2].y4 + tempRow[7].y4), 0)
                    tempRow[8] = tempobj
                    break;
                case 9:
                    tempobj['y4'] = Math.round(y3HWM, 0)
                    tempRow[9] = tempobj
                    break;
                case 10:
                    tempobj['y4'] = Math.round((Math.max(tempRow[9].y4, tempRow[0].y4)) * (parseFloat(formInfo.rateOfReturn) / 100), 0)
                    tempRow[10] = tempobj
                    break;
                case 11:
                    if (tempRow[8].y4 > (tempRow[9].y4 + tempRow[10].y4)) {
                        tempobj['y4'] = Math.round((tempRow[8].y4 - tempRow[9].y4 - tempRow[10].y4), 0)
                        tempRow[11] = tempobj
                    } else {
                        tempobj['y4'] = 0
                        tempRow[11] = tempobj
                    }
                    break;
                case 12:
                    tempobj['y4'] = Math.round((tempRow[11].y4 * (parseFloat(formInfo.performance) / 100)), 0)
                    tempRow[12] = tempobj
                    break;
                case 13:
                    tempobj['y4'] = Math.round(tempRow[12].y4, 0)
                    tempRow[13] = tempobj
                    break;
                case 14:
                    if (tempRow[12].y4 > 0) {
                        tempobj['y4'] = "Yes"
                        tempRow[14] = tempobj
                    }
                    else {
                        tempobj['y4'] = "No P Fees"
                        tempRow[14] = tempobj
                    }
                    break;
                case 15:
                    tempobj['y4'] = Math.round((tempRow[8].y4 - tempRow[12].y4), 0)
                    tempRow[15] = tempobj
                    y4NetValue = tempobj['y4']
                    break;
                case 16:
                    tempobj['y4'] = `${(((tempRow[15].y4 / tempRow[0].y4) - 1) * 100).toFixed(2)}%`
                    tempRow[16] = tempobj
                    break;
                case 17:
                    if (tempRow[14].y4 === "Yes") {
                        tempobj['y4'] = tempRow[8].y4
                        tempRow[17] = tempobj
                        y4HWM = tempobj['y4']
                    } else {
                        tempobj['y4'] = Math.max(tempRow[8].y4, tempRow[0].y4, y3HWM)
                        tempRow[17] = tempobj
                        y4HWM = tempobj['y4']
                    }
                    break;
                default:
                    return null;
            }
        }
        )
        rowData = JSON.parse(JSON.stringify(tempRow))
    }
    const updateCalculatedy5Values = () => {
        const tempRow = JSON.parse(JSON.stringify(rowData))
        tempRow.forEach((row, index) => {
            let tempobj = { ...row }
            switch (index) {
                case 0:
                    tempobj['y5'] = y4NetValue;
                    tempRow[0] = tempobj
                    break;

                case 1:
                    const calValue = (gross.y5Gross) / 100
                    tempobj['y5'] = Math.round(y4NetValue * calValue, 0);
                    tempRow[1] = tempobj
                    break;
                case 2:
                    tempobj['y5'] = Math.round(tempRow[0].y5 + tempRow[1].y5, 0)
                    tempRow[2] = tempobj
                    break;
                case 3:
                    tempobj['y5'] = Math.round((tempRow[2].y5 + tempRow[0].y5) / 2, 0)
                    tempRow[3] = tempobj
                    break;
                case 4:
                    tempobj['y5'] = -(Math.round(tempRow[3].y5 * (parseFloat(formInfo.otherExpense) / 100), 0))
                    tempRow[4] = tempobj
                    break;
                case 5:
                    const brokValue = (parseFloat(formInfo.bokarAge) / 100)
                    const result = -(Math.round(tempRow[3].y5 * brokValue, 0))
                    tempobj['y5'] = result
                    tempRow[5] = tempobj
                    break;
                case 6:
                    tempobj['y5'] = -(Math.round((tempRow[3].y5 + tempRow[4].y5 + tempRow[5].y5) * (parseFloat(formInfo.Mangement) / 100), 0))
                    tempRow[6] = tempobj
                    break;
                case 7:
                    tempobj['y5'] = Math.round((tempRow[4].y5 + tempRow[5].y5 + tempRow[6].y5), 0)
                    tempRow[7] = tempobj
                    break;
                case 8:
                    tempobj['y5'] = Math.round((tempRow[2].y5 + tempRow[7].y5), 0)
                    tempRow[8] = tempobj
                    break;
                case 9:
                    tempobj['y5'] = Math.round(y4HWM, 0)
                    tempRow[9] = tempobj
                    break;
                case 10:
                    tempobj['y5'] = Math.round((Math.max(tempRow[9].y5, tempRow[0].y5)) * (parseFloat(formInfo.rateOfReturn) / 100), 0)
                    tempRow[10] = tempobj
                    break;
                case 11:
                    if (tempRow[8].y5 > (tempRow[9].y5 + tempRow[10].y5)) {
                        tempobj['y5'] = Math.round((tempRow[8].y5 - tempRow[9].y5 - tempRow[10].y5), 0)
                        tempRow[11] = tempobj
                    } else {
                        tempobj['y5'] = 0
                        tempRow[11] = tempobj
                    }
                    break;
                case 12:
                    tempobj['y5'] = Math.round((tempRow[11].y5 * (parseFloat(formInfo.performance) / 100)), 0)
                    tempRow[12] = tempobj
                    break;
                case 13:
                    tempobj['y5'] = Math.round(tempRow[12].y5, 0)
                    tempRow[13] = tempobj
                    break;
                case 14:
                    if (tempRow[12].y5 > 0) {
                        tempobj['y5'] = "Yes"
                        tempRow[14] = tempobj
                    }
                    else {
                        tempobj['y5'] = "No P Fees"
                        tempRow[14] = tempobj
                    }
                    break;
                case 15:
                    tempobj['y5'] = Math.round((tempRow[8].y5 - tempRow[12].y5), 0)
                    tempRow[15] = tempobj
                    break;
                case 16:
                    tempobj['y5'] = `${(((tempRow[15].y5 / tempRow[0].y5) - 1) * 100).toFixed(2)}%`
                    tempRow[16] = tempobj
                    break;
                case 17:
                    if (tempRow[14].y5 === "Yes") {
                        tempobj['y5'] = tempRow[8].y5
                        tempRow[17] = tempobj
                    } else {
                        tempobj['y5'] = Math.max(tempRow[8].y5, tempRow[0].y5, y4HWM)
                        tempRow[17] = tempobj

                    }
                    break;
                default:
                    return null;
            }
        }
        )
        rowData = JSON.parse(JSON.stringify(tempRow))
        if(feeType==="Fixed Fee Structure"){
            let unneccsaryColumn=["ix",'x','xi','xii','xiii','xiv','xv','xviii']
            let fliterRowData=rowData.filter((it)=>{
                return !unneccsaryColumn.includes(it?.id)
        });
        fliterRowData.map((itm)=>{
            if(itm.id==='xvi'){
               itm.id= itm.id.replace('xvi','ix');
               itm.formula='ix=iii-viii'
            }if(itm.id==='xvii'){
               itm.id= itm.id.replace('xvii','x')
               itm.formula='x=((ix/i)-1)%'
            }
          
        })
            setTableData(fliterRowData)
        }else{
            setTableData(rowData)
        }
       
    }
    useEffect(() => {
        if(formInfo.Mangement==="0" && formInfo.performance==="0"){
            
            setError("* Please update applicable Fee Rate")
        }else{
            setError("")
        }
        const timeout = setTimeout(() => {
            if(formInfo.Mangement==="" ||formInfo.performance===""||formInfo.rateOfReturn===""){
                return;
            }
            if(formInfo.Capital>=500000){
                setError("")
            updateCalculatedValues();
            updateCalculatedy2Values();
            updateCalculatedy3Values();
            updateCalculatedy4Values();
            updateCalculatedy5Values();
            }else{
                setError("Please Enter more than 5,00,000")
            }
        }, 3000)
        return () => {
            if (timeout) {
                clearTimeout(timeout)
            }
        }
    }, [gross, formInfo])
    
    const handleGrossChange = (e) => {
        const { name, value } = e.target;
        if (regNegNumber.test(value)) {
            if (value < -90) {
                setError("Please enter value more than -90%")
            } else {
                setGross({
                    ...gross,
                    [name]: value,
                });
            }
        }
    }
    const currencyComma = (value) => {
        return value?.replace(/(\d)(?=(\d\d)+\d$)/g, '$1,')
      }
    return (
        <div>
            <img src="./Capture.PNG" alt="" className="logo"/>
            <div className="fee-Container">
                <h3 style={{ marginBottom: "25px" }}>Fee Calculator Illustration</h3>
                <FormControl sx={{ minWidth: 250, backgroundColor: "#FFF",
                    
                    '& .MuiOutlinedInput-root':{
                        '& fieldset':{
                             borderColor:"#C58882",
                            borderWidth:'2px'
                        },
                        '&.Mui-focused fieldset':{
                                        borderColor:"#C58882",
                                        borderWidth:'2px'
                                    },
                        '&:hover fieldset':{
                              borderColor:"#C58882",
                                        borderWidth:'2px'
                        }
                    }
                 }}>
                    <InputLabel id="demo-simple-select-label">FeeType</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={feeType}
                        label="Fee Type"
                        onChange={handleDropDownChange}
                        className="drop-down"
                       sx={{height:"40px"
                       }}
                    >
                        <MenuItem value="Fixed Fee Structure">Fixed Fee Structure</MenuItem>
                        <MenuItem value="Performance Fee Structure">Performance Fee Structure</MenuItem>
                        <MenuItem value="Hybrid Fee Structure">Hybrid Fee Structure</MenuItem>
                    </Select>
                </FormControl>
            </div>
            <div className="text-container">
                <Grid2 container spacing={4}>
                    <Grid2 item size={{ xs: 4, md: 4, sm: 4 }}>
                        <AtomTextField
                            label="Capital Contribution (Rs.)"
                            sx={{ width: "100%",
                                '& .MuiOutlinedInput-root':{
                                    '& fieldset':{
                                        borderColor:"#C58882",
                                        borderWidth:'2px'
                                    },
                                    '&.Mui-focused fieldset':{
                                        borderColor:"#C58882",
                                        borderWidth:'2px'
                                    },
                                    '&:hover fieldset':{
                                        borderColor:"#C58882",
                                                  borderWidth:'2px'
                                  }
                                }
                                
                                
                             }}
                            onChange={handleChange}
                            name="Capital"
                            value={currencyComma(formInfo?.Capital?.toString())}

                        />
                    </Grid2>
                    <Grid2 item size={{ xs: 4, md: 4, sm: 4 }}>
                        <AtomTextField
                            label="Management Fee (%age per annum)"
                            sx={{ width: "100%",
                                '& .MuiOutlinedInput-root':{
                                    '& fieldset':{
                                        borderColor:feeType === "Fixed Fee Structure" || feeType === "Hybrid Fee Structure" ? "#C58882":"",
                                        borderWidth:feeType === "Fixed Fee Structure" || feeType === "Hybrid Fee Structure" ? "2px":""
                                    },
                                    '&.Mui-focused fieldset':{
                                          borderColor:feeType === "Fixed Fee Structure" || feeType === "Hybrid Fee Structure" ? "#C58882":"",
                                        borderWidth:feeType === "Fixed Fee Structure" || feeType === "Hybrid Fee Structure" ? "2px":""
                                    },
                                    '&:hover fieldset':{
                                       borderColor:feeType === "Fixed Fee Structure" || feeType === "Hybrid Fee Structure" ? "#C58882":"",
                                        borderWidth:feeType === "Fixed Fee Structure" || feeType === "Hybrid Fee Structure" ? "2px":""
                                  }
                                }
                             }}
                            onChange={handleChange}
                            // className={feeType === "Fixed Fee Structure" || feeType === "Hybrid Fee Structure" ? "highlight-border" : ""}
                            name="Mangement"
                            value={formInfo.Mangement}
                            InputProps={{
                                sx:{height:"40px"},
                                endAdornment: <span>%</span>
                            }}
                            helperText=""
                            required={formInfo.Mangement==="0" && formInfo.performance==="0"?true:false}
                            disabled={feeType === "Fixed Fee Structure" || feeType === "Hybrid Fee Structure" ? false : true}
                        />
                    </Grid2>
                    <Grid2 item size={{ xs: 4, md: 4, sm: 4 }}>
                        <AtomTextField
                            label="Other Expenses (%age per annum)"
                            sx={{ width: "100%" }}
                            onChange={handleChange
                            }
                            name="otherExpense"
                            value={formInfo.otherExpense}
                            disabled={true}
                            InputProps={{
                                sx:{height:"40px"},
                                endAdornment: <span>%</span>
                            }}
                            helperText=""
                        />
                    </Grid2>
                    <Grid2 item size={{ xs: 4, md: 4, sm: 4 }}>
                        <AtomTextField
                            label="Performance Fee (%age per annum)"
                            sx={{ width: "100%",
                                '& .MuiOutlinedInput-root':{
                                    '& fieldset':{
                                        borderColor:feeType !== "Fixed Fee Structure"? "#C58882":"",
                                        borderWidth:feeType !== "Fixed Fee Structure" && "2px",
                                    },
                                    '&.Mui-focused fieldset':{
                                        borderColor:feeType !== "Fixed Fee Structure"? "#C58882":"",
                                        borderWidth:feeType !== "Fixed Fee Structure"&& "2px",
                                    },
                                    '&:hover fieldset':{
                                        borderColor:feeType !== "Fixed Fee Structure"? "#C58882":"",
                                        borderWidth:feeType !== "Fixed Fee Structure"&& "2px",
                                  }
                                }
                                
                             }}
                            onChange={handleChange
                            }
                            name="performance"
                            value={formInfo.performance}
                            InputProps={{
                                sx:{height:"40px"},
                                endAdornment: <span>%</span>
                            }}
                            helperText=""
                            required={formInfo.Mangement==="0" && formInfo.performance==="0"?true:false}
                            disabled={feeType === "Fixed Fee Structure" ? true : false}
                        />
                    </Grid2>
                    <Grid2 item size={{ xs: 4, md: 4, sm: 4 }}>
                        <AtomTextField
                            label="Hurdle Rate of Return (%age per annum)"
                            sx={{ width: "100%"
                                ,
                                '& .MuiOutlinedInput-root':{
                                    '& fieldset':{
                                        borderColor:feeType !== "Fixed Fee Structure"? "#C58882":"",
                                        borderWidth:feeType !== "Fixed Fee Structure"&& "2px",
                                    },
                                    '&.Mui-focused fieldset':{
                                        borderColor:feeType !== "Fixed Fee Structure"? "#C58882":"",
                                        borderWidth:feeType !== "Fixed Fee Structure"&& "2px",
                                    },
                                    '&:hover fieldset':{
                                        borderColor:feeType !== "Fixed Fee Structure"? "#C58882":"",
                                        borderWidth:feeType !== "Fixed Fee Structure"&& "2px",
                                  }
                                }
                                
                             }}
                            onChange={handleChange
                            }
                            name="rateOfReturn"
                            value={formInfo.rateOfReturn}
                            InputProps={{
                                sx:{height:"40px"},
                                endAdornment: <span>%</span>
                            }}
                            helperText=""
                            disabled={feeType === "Fixed Fee Structure" ? true : false}
                        />
                    </Grid2>
                    <Grid2 item size={{ xs: 4, md: 4, sm: 4 }}>
                        <AtomTextField
                            label="Brokerage and Transaction cost"
                            sx={{ width: "100%" }}
                            onChange={handleChange
                            }
                            name="bokarAge"
                            value={formInfo.bokarAge}
                            disabled={true}
                            InputProps={{
                                sx:{height:"40px"},
                                endAdornment: <span>%</span>
                            }}
                            helperText=""

                        />
                    </Grid2>
                </Grid2>
                <div style={{ padding: 10 }}>
                    {error && <Alert severity="error" onClose={() => setError("")}>{error}</Alert>}
                </div>
                <div style={{ marginTop: "20px" }}>
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 ,border:"1px solid black"}} size="small" 
                        >
                            <TableHead >
                                <TableRow>
                                    <TableCell className="tableHead" colSpan={3} rowSpan={2} align="center">Fees</TableCell>
                                    <TableCell align="left" className="tableHead" sx={{ padding: 1 }}>
                                        <div className="row-span" >
                                            <span>Year 1</span>
                                            <span>Gain/Loss</span>
                                        </div>
                                    </TableCell>
                                    <TableCell align="left" className="tableHead" sx={{ padding: 1 }}> <div className="row-span">
                                        <span>Year 2</span>
                                        <span>Gain/Loss</span>
                                    </div></TableCell>
                                    <TableCell align="left" className="tableHead" sx={{ padding: 1 }}> <div className="row-span">
                                        <span>Year 3</span>
                                        <span>Gain/Loss</span>
                                    </div></TableCell>
                                    <TableCell align="left" className="tableHead" sx={{ padding: 1 }}> <div className="row-span">
                                        <span>Year 4</span>
                                        <span>Gain/Loss</span>
                                    </div></TableCell>
                                    <TableCell align="left" className="tableHead" sx={{ padding: 1 }}> <div className="row-span">
                                        <span>Year 5</span>
                                        <span>Gain/Loss</span>
                                    </div></TableCell>
                                </TableRow>
                                <TableRow >
                                    <TableCell align="center" className="tableHead"><input className="input-normal" name="y1Gross" type="text" onChange={(e) => handleGrossChange(e)} value={gross.y1Gross} /><span>%</span></TableCell>
                                    <TableCell align="center" className="tableHead"><input className="input-normal" name="y2Gross" type="text" onChange={(e) => handleGrossChange(e)} value={gross.y2Gross} /><span>%</span></TableCell>
                                    <TableCell align="center" className="tableHead"><input className="input-normal" name="y3Gross" type="text" onChange={(e) => handleGrossChange(e)} value={gross.y3Gross} /><span>%</span></TableCell>
                                    <TableCell align="center" className="tableHead"><input className="input-normal" name="y4Gross" type="text" onChange={(e) => handleGrossChange(e)} value={gross.y4Gross} /><span>%</span></TableCell>
                                    <TableCell align="center" className="tableHead"><input className="input-normal" name="y5Gross" type="text" onChange={(e) => handleGrossChange(e)} value={gross.y5Gross} /><span>%</span></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody >
                                {tableData?.map((row, index) => (
                                    <TableRow
                                        key={index}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell className="table-row" component="th" scope="row">
                                            {row?.Fee}
                                        </TableCell>
                                        <TableCell className="table-row" align="left" >{row?.id}</TableCell>
                                        <TableCell className="table-row" align="left">{row?.formula}</TableCell>
                                        <TableCell className="table-row" align="center" sx={{ color: row?.y1 < 0 ? "red" : "" }} >{row?.y1?.toLocaleString("en-IN", { maximumFractionDigits: 3 })}</TableCell>
                                        <TableCell className="table-row" align="center" sx={{ color: row?.y2 < 0 ? "red" : "" }} >{row?.y2?.toLocaleString("en-IN", { maximumFractionDigits: 3 })}</TableCell>
                                        <TableCell className="table-row" align="center" sx={{ color: row?.y3 < 0 ? "red" : "" }} >{row?.y3?.toLocaleString("en-IN", { maximumFractionDigits: 3 })}</TableCell>
                                        <TableCell className="table-row" align="center" sx={{ color: row?.y4 < 0 ? "red" : "" }}>{row?.y4?.toLocaleString("en-IN", { maximumFractionDigits: 3 })}</TableCell>
                                        <TableCell className="table-row" align="center" sx={{ color: row?.y5 < 0 ? "red" : "" }}>{row?.y5?.toLocaleString("en-IN", { maximumFractionDigits: 3 })}</TableCell>
                                    </TableRow>

                                ))}

                            </TableBody>
                        </Table>
                    </TableContainer>
                    <div style={{marginTop:10}}>
                    <span style={{fontWeight:800}}>Notes:</span>
                    </div>
                    <TableContainer component={Paper} >
                        <Table>
                            <TableBody>
                                {rules.map((row, index) => (
                                    <TableRow
                                        key={index}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell className="table-row" component="th" scope="row">{row.id}</TableCell>
                                        <TableCell className="table-row" component="th" scope="row">
                                            {row.Name}
                                        </TableCell>
                                    </TableRow>

                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>

            </div>
        </div>
    )
}

export default ManagementCalculator;